// "Approve all" from the weekly email (screens 35, 36). Opening the link shows the posts;
// the button approves, so mail apps that check links never approve anything by themselves.
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import { ApiError, api, post } from "../api";

interface ActionView {
  workspaceId: string;
  brand: string;
  site: string;
  wallName: string | null;
  used: boolean;
  result: string | null;
  posts: { id: string; creator: string; imageUrl: string; status: string }[];
}

export function EmailAction() {
  const { token } = useParams();
  const [view, setView] = useState<ActionView | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api<ActionView>(`/v1/public/actions/${token}`)
      .then(setView)
      .catch((e) => setError(e instanceof ApiError ? e.message : "This link isn't valid."));
  }, [token]);

  const approve = async () => {
    setBusy(true);
    try {
      setView(await post<ActionView>(`/v1/public/actions/${token}/approve`, {}));
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="public">
      <main className="sheet" aria-live="polite">
        <img src="/logo.svg" alt="Brandwall" style={{ height: 26 }} />
        {error && <div className="error">{error}</div>}
        {view && !view.used && (
          <>
            <h1 style={{ fontSize: 22 }}>
              Approve {view.posts.length} post{view.posts.length === 1 ? "" : "s"} for your{" "}
              {view.wallName ?? "wall"}?
            </h1>
            <div className="email-grid">
              {view.posts.map((p) => (
                <img key={p.id} src={p.imageUrl} alt={`Post by @${p.creator || "a creator"}`} />
              ))}
            </div>
            <button type="button" className="btn ok block" disabled={busy} onClick={approve}>
              {busy ? "Approving…" : `Approve all ${view.posts.length}`}
            </button>
            <Link className="btn secondary block" to={`/w/${view.workspaceId}/inbox`}>
              Review them one by one
            </Link>
          </>
        )}
        {view?.used && (
          <>
            <h1 style={{ fontSize: 24 }}>{view.result}</h1>
            <p className="muted">
              Approved posts show on your {view.wallName ?? "wall"} on {view.site} as soon as they
              have their creator's permission.
            </p>
            <Link className="btn block" to={`/w/${view.workspaceId}`}>
              Open Brandwall
            </Link>
          </>
        )}
      </main>
    </div>
  );
}
